/**
 * Constantes das meta tags de identificação, SEO e Open Graph.
 *
 * OS 0007/2026 (Governança Web) — Capítulo III, Seção II e Seção V.
 */

/**
 * O padrão Open Graph só reconhece um punhado de valores. Para o portal
 * interessam `article` (conteúdo datado, com seção e autor) e `website`.
 */
export const OG_TYPE_BY_PORTAL_TYPE: Record<string, string> = {
  News: 'article',
  Noticia: 'article',
  'News Item': 'article',
  Event: 'article',
};

export const DEFAULT_OG_TYPE = 'website';

export const ARTICLE_PORTAL_TYPES = Object.keys(OG_TYPE_BY_PORTAL_TYPE);

/**
 * `og:locale` exige `idioma_REGIÃO`, com underscore e região em maiúsculas; o
 * Plone entrega `pt-br`. Sem o de-para o Facebook descarta a tag.
 */
export const OG_LOCALE_BY_LANGUAGE: Record<string, string> = {
  'pt-br': 'pt_BR',
  en: 'en_US',
  es: 'es_ES',
};

export const DEFAULT_OG_LOCALE = 'pt_BR';

export const TITLE_SEPARATOR = '—';

/** Usado enquanto o `@site` não chegou ao store. */
export const DEFAULT_SITE_NAME = 'Ministério Público Federal';
